import { token } from '@atlaskit/tokens';
import HyperlinkLink from '@databases/content-link/HyperlinkLink';
import { type DatabaseFieldType } from '@databases/types/database';
import { makeValidHyperlink } from '@databases/utils/utils';
import React, { type FunctionComponent } from 'react';
import styled from 'styled-components';

import { type ViewComponentProps } from './types';

const Container = styled.ul`
  list-style-type: none;
  padding: 0;
  width: 100%;

  > li + li {
    margin-top: ${token('space.075', '6px')};
  }
`;

const preventDefault = (e: React.MouseEvent | React.FocusEvent) => {
  // Prevent propagation to inline edit
  e.stopPropagation();
};

const HyperlinkValueView: FunctionComponent<
  ViewComponentProps<DatabaseFieldType.HYPERLINK>
> = ({ field, value, noFocus, showDisabledValue }) => {
  return (
    <Container>
      {value.map(makeValidHyperlink).map((v, i) => (
        <li key={i} data-testid="hyperlink-value-view-item">
          <HyperlinkLink
            hyperlink={v}
            noFocus={noFocus}
            onClick={preventDefault}
            onFocus={preventDefault}
            noResolve={!field.settings.resolve}
            useSmartLink
            showDisabledValue={showDisabledValue}
          />
        </li>
      ))}
    </Container>
  );
};

export default HyperlinkValueView;
